import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _createForOfIteratorHelper from '@babel/runtime/helpers/createForOfIteratorHelper';

var bindRefs = function bindRefs() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }

  return function (el) {
    return refs.forEach(function (ref) {
      if (typeof ref === "function") ref(el);else if (ref) ref.current = el;
    });
  };
};

function chainHandlers() {
  for (var _len2 = arguments.length, callbacks = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    callbacks[_key2] = arguments[_key2];
  }

  return function () {
    var _iterator = _createForOfIteratorHelper(callbacks),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var callback = _step.value;

        if (typeof callback === "function") {
          callback.apply(void 0, arguments);
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  };
}

function mergeProps() {
  var result = {};

  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }

  for (var _i = 0, _args = args; _i < _args.length; _i++) {
    var props = _args[_i];

    for (var key in result) {
      if (/^on[A-Z]/.test(key) && typeof result[key] === "function" && typeof props[key] === "function") {
        result[key] = chainHandlers(result[key], props[key]);
      } else if (key === "ref") {
        result[key] = bindRefs(result[key], props[key]);
      } else if (key === "style") {
        result[key] = _objectSpread(_objectSpread({}, result[key]), props[key] ? props[key] : {});
      } else {
        result[key] = props[key] !== void 0 ? props[key] : result[key];
      }
    }

    for (var _key4 in props) {
      if (result[_key4] === void 0) {
        result[_key4] = props[_key4];
      }
    }
  }

  return result;
}
function getValidElement(maybeElement, message) {
  if (maybeElement instanceof Element) return maybeElement;
  if (message) console.error(message);
  return void 0;
}

export { bindRefs, getValidElement, mergeProps };
